import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { doughnutLabelsLine, options } from './chartConfig';
import { Box, Flex } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

ChartJS.register(ArcElement, Tooltip, Legend);

export interface IData {
	value: number;
	label: string;
	color: string;
}

export const Chart = ({ dataset }: { dataset: IData[] }) => {
	const data = {
		labels: dataset.map(el => '  ' + el.label),
		datasets: [
			{
				label: 'Tokenomics',
				data: dataset.map(el => el.value),
				backgroundColor: dataset.map(el => el.color),
				hoverBackgroundColor: dataset.map(el => el.color),
				borderColor: Color.FORM_BACKGROUND,
				borderWidth: 4,
			},
		],
	};

	return (
		<Flex h="400px">
			<Doughnut
				data={data}
				options={options as any}
				plugins={[doughnutLabelsLine]}
			/>
		</Flex>
	);
};
